import { Routes } from '@angular/router';
import { LandingComponent } from '../home/landing/landing.component';
import { UprofileComponent } from '../home/uprofile/uprofile.component';
import { VprofileComponent } from '../home/vprofile/vprofile.component';
import { AddFolderComponent } from '../home/add-folder/add-folder.component';
import { ChallengeForumComponent } from '../home/challenge-forum/challenge-forum.component';
import { MyAttendanceComponent } from '../home/my-attendance/my-attendance.component';
import { ReportComponent } from '../home/report/report.component';
import { PageComponent } from '../home/page/page.component';
import { ForumComponent } from '../home/forum/forum.component';
import { ForumdetailComponent } from '../home/forumdetail/forumdetail.component';
import { AnnouncementlistComponent } from '../home/announcementlist/announcementlist.component';
import { TopicdetailComponent } from '../home/topicdetail/topicdetail.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { FreedownloadComponent } from './freedownload/freedownload.component';
import { VpgComponent } from './vpg/vpg.component';
import { VpgdetailComponent } from './vpgdetail/vpgdetail.component';
import { VerificationComponent } from './verification/verification.component';
import { BlogComponent } from '../home/blog/blog.component';
import { GroupComponent } from './group/group.component';
import { GroupdetailComponent } from './groupdetail/groupdetail.component';
import { VjobComponent } from './vjob/vjob.component';
import { VjobdetailComponent } from './vjobdetail/vjobdetail.component';
import { ExamsolutionComponent } from './examsolution/examsolution.component';
import { UserBookmarksComponent } from '../home/user-bookmarks/user-bookmarks.component';
import { TestingComponent } from './testing/testing.component';
import { ProfileComponent } from './profile/profile.component';
import { OtopicdetailComponent } from './otopicdetail/otopicdetail.component';
import { RankPredictorComponent } from './rank-predictor/rank-predictor.component';
import { SetnewpasswordComponent } from './setnewpassword/setnewpassword.component';


import { VfaqComponent } from './vfaq/vfaq.component';

import { PackagelistComponent } from './packagelist/packagelist.component';
import { PackagedetailComponent } from './packagedetail/packagedetail.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { StudentPaymentFormComponent } from './student-payment-form/student-payment-form.component';
import { MypackagesComponent } from './mypackages/mypackages.component';
import { MypackagedetailComponent } from './mypackagedetail/mypackagedetail.component';
import { PackagedataComponent } from './packagedata/packagedata.component';
import { PaymentComponent } from './payment/payment.component';
import { PackageinvoiceComponent } from './packageinvoice/packageinvoice.component';
import { TimelineComponent } from './timeline/timeline.component';
import { EvaluateAnswerSheetComponent } from './evaluate-answer-sheet/evaluate-answer-sheet.component';
import { PackageinvoicelistComponent } from './packageinvoicelist/packageinvoicelist.component';
import { StudentreportComponent } from './studentreport/studentreport.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { PackageInvDownloadComponent } from './package-inv-download/package-inv-download.component';
import { StudentrankreportComponent } from './studentrankreport/studentrankreport.component';
import { StudentStructureReportComponent } from './student-structure-report/student-structure-report.component';
import { GroupmembersComponent } from './groupmembers/groupmembers.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';
 import { TopperstalkComponent } from './topperstalk/topperstalk.component';
 import { ToppersdetailComponent } from '../home/toppersdetail/toppersdetail.component';
import { AddtoppersdetailComponent } from '../home/addtoppersdetail/addtoppersdetail.component';
import { JobannouncementlistComponent } from './jobannouncementlist/jobannouncementlist.component';
import { VjobfulllistComponent } from './vjobfulllist/vjobfulllist.component';
import { DailyquizComponent } from '../online-mcq/dailyquiz/dailyquiz.component';
import { QuickreportComponent } from '../online-mcq/quickreport/quickreport.component';
import { OverallreportComponent } from '../online-mcq/overallreport/overallreport.component';
import { QuizlistComponent } from '../online-mcq/quizlist/quizlist.component';
import { DailyquizreportComponent } from '../online-mcq/dailyquizreport/dailyquizreport.component';
import { ProductlistComponent } from '../ecommerce/productlist/productlist.component';
import { EvaluateAnswerUploadComponent } from './evaluate-answer-upload/evaluate-answer-upload.component';

export const HomeRoutes: Routes = [
  {
    path: '',
    children: [
 	  {
        path: '',
        component: SetnewpasswordComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Set new password',
          path: 'setnewpassword',
          urls: '/home/setnewpassword',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },
      {
        path: 'fm',
        component: LandingComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/landing'
        }
      },
      {
        path: 'pg',
        component: VpgComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/vpg'
        }
      },

      {
        path: 'pgdetail',
        component: VpgdetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/vpg'
        }
      }, {
        path: 'topic/:id',
        component: TopicdetailComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/topicdetail',
        }
      },
      {
        path: 'dashboard',
        component: UprofileComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/uprofile',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'helpdesk',
        component: HelpdeskComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/helpdesk',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'helpdesk/:id',
        component: HelpdeskComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/helpdesk',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      }
      ,
      {
        path: 'viewprofile',
        component: VprofileComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/vprofile',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'forum',
        component: ForumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/forum',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'forum/:id',
        component: LandingComponent,
        // canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/forum',

        }
      },
      {
        path: 'forum/detail/:id',
        component: ForumdetailComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/forum',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'blog',
        component: BlogComponent,
        // canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/blog',

        }
      },
      {
        path: 'blog/:id',
        component: BlogComponent,
        // canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/blog',

        }
      },
      {
        path: 'announcement',
        component: AnnouncementlistComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/uprofile',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'challenge',
        component: ChallengeForumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/challenge-forum',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'exam-solution',
        component: ExamsolutionComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/examsolution',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },
      {
        path: 'faq',
        component: VfaqComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/vfaq',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },
      {
        path: 'rankPredictor',
        component: RankPredictorComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          path: 'rankPredictor',
          urls: '/home/rank-predictor',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },
      /*{
        path: 'setnewpassword',
        component: SetnewpasswordComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          path: 'setnewpassword',
          urls: '/home/setnewpassword',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },*/
      {
        path: 'attendance',
        component: MyAttendanceComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/my-attendance',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'report',
        component: ReportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/report',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'folder',
        component: AddFolderComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/add-folder',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'about-us',
        component: PageComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/page'
        }
      },
      {
        path: 'new-batch',
        component: PageComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/page'
        }
      }, {
        path: 'fee-structure',
        component: PageComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/page'
        }
      }
      , {
        path: 'gallery',
        component: PageComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/page'
        }
      }, {
        path: 'contact',
        component: PageComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/page'
        }
      }, {
        path: 'free-download',
        component: FreedownloadComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/freedownload'
        }
      },
      {
        path: 'verification/:id',
        component: VerificationComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/verification'
        }
      },
      {
        path: 'groups',
        component: GroupComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/group'
        }
      },
      {
        path: 'groups/:id',
        component: GroupdetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/groupdetail'
        }
      }, {
        path: 'groups/:id/:feedid',
        component: GroupdetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/groupdetail'
        }
      },
      {
        path: 'job-notifications',
        component: VjobComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/vjob'
        }
      },

      {
        path: 'jobdetail',
        component: VjobdetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/vjobdetail'
        }
      },
      {
        path: 'bookmarks/:id',
        component: UserBookmarksComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/user-bookmarks',
        }
      },
      {
        path: 'testing/:id',
        component: TestingComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/testing',
        }
      },
      {
        path: 'profile/:id',
        component: ProfileComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/profile'
        }
      },
      {
        path: 'otopic/:id',
        component: OtopicdetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/otopicdetail',
        }
      },
      {
        path: '',
        component: PackagelistComponent,
        data: {
          title: 'Buy Test Series for GATE, ESE, SSC, PSU Exam - Student Portal',
          urls: '/home/packagelist',

        }
      },
      {
        path: 'buy-test-series/:id',
        component: PackagelistComponent,
        data: {
          title: 'Buy Test Series for GATE, ESE, SSC, PSU Exam - Student Portal',
          urls: '/home/packagelist',

        }
      },
      {
        path: 'packagedata/:id',
        component: PackagedataComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/packagedata',

        }
      },
      {
        path: 'packagedetail/:id',
        component: PackagedetailComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/packagedetail',
        }
      },
      {
        path: 'student-form-pre-payment/:id',
        component: StudentPaymentFormComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/student-payment-form',

        }
      },
      {
        path: 'mypackages',
        component: MypackagesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/mypackages',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'mypackages/:id',
        component: MypackagesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/mypackages',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'mypackagedetail/:id',
        component: MypackagedetailComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/mypackagedetail',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'payment/success/:id',
        component: PaymentComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      }, {
        path: 'packageinvoice/:id',
        component: PackageinvoiceComponent,

        data: {
          title: 'Made Easy',
          urls: '/home/packageinvoice',

        }
      },
      {
        path: 'package-inv-download',
        component: PackageInvDownloadComponent,

        data: {
          title: 'Made Easy',
          urls: '/home/package-inv-download',

        }
      }, {
        path: 'packageinvoicelist',
        component: PackageinvoicelistComponent,

        data: {
          title: 'Made Easy',
          urls: '/home/packageinvoicelist',

        }
      },
      {
        path: 'timeline',
        component: TimelineComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '',
          permissions:
          {
            only: ['teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'evaluate-answer-sheet/:id',
        component: EvaluateAnswerSheetComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '',
          permissions:
          {
            only: ['teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'studentreport',
        component: StudentreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/studentreport',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'studentrankreport/:id',
        component: StudentrankreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/studentrankreport',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'paystatus/:id',
        component: PaymentsuccessComponent,
        //canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/paymentsuccess',
          // permissions: 
          // {
          //   only: ['student','gueststudent','teacher'],
          //   redirectTo: '/'
          // }
        }
      },
      {
        path: 'studentreport/:id',
        component: StudentreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/studentreport',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'student-structure-report',
        component: StudentStructureReportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          title: 'Made Easy',
          urls: '/home/student-structure-report',
          permissions:
          {
            only: ['student', 'gueststudent', 'teacher'],
            redirectTo: '/'
          }
        }
      },
      {
        path: 'jobfulllist',
        component: VjobfulllistComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/vjobfulllist'
        }
      },
      {
        path: 'groupmembers/:id',
        component: GroupmembersComponent,
        data: {
          title: 'Made Easy',
          urls: ''
        }
      },
      {
        path: 'topperstalk',
        component: TopperstalkComponent,
        data: {
          title: 'Toppers Talk',
          urls: '/home/topperstalk'
        }
      },
      {
        path: 'toppersdetail',
        component: ToppersdetailComponent,
        data: {
          title: 'Toppers Detail',
          urls: '/home/toppersdetail'
        }
      },
      {
        path: 'addtoppersdetail',
        component: AddtoppersdetailComponent,
        data: {
          title: 'Add Toppers Detail',
          urls: '/home/addtoppersdetail'
        }
      },
      {
        path:'toppersdetail/:id',
        component:ToppersdetailComponent,
        data:{
        title:'Made Easy',
        urls:'/home/toppersdetail'
        }
      },
      {
        path: 'jobannouncementlist',
        component: JobannouncementlistComponent,
        data: {
          title: 'Made Easy',
          urls: '/home/jobannouncementlist'
        }
      },
      {
        path: 'dailyquiz',
        component: DailyquizComponent,
        data: {
          title: 'Made Easy',
          urls: '/online-mcq/dailyquiz'
        }
      },
      {
        path: 'dailyquiz/:id',
        component: DailyquizComponent,
        data: {
          title: 'Made Easy',
          urls: '/online-mcq/dailyquiz'
        }
      } ,
   

    {
      path: 'overallreport/:id',
      component: OverallreportComponent,
      data: {
        title: 'Made Easy',
        urls: '/online-mcq/overallreport'
      }
    },
    {
      path: 'quizlist',
      component: QuizlistComponent,
      data: {
        title: 'Made Easy',
        urls: '/online-mcq/quizlist'
      }
    },
    {
      path: 'quizlist/:id',
      component: QuizlistComponent,
      data: {
        title: 'Made Easy',
        urls: '/online-mcq/quizlist'
      }
    },
    {
      path: 'dailyquizreport',
      component: DailyquizreportComponent,
      data: {
        title: 'Report list - Made Easy',
        urls: '/online-mcq/dailyquizreport'
      }
    },
    {
      path: 'productlist',
      component: ProductlistComponent,
      data: {
        title: 'Report list - Made Easy',
        urls: '/ecommerce/productlist'
      }
    } ,
    {
      path: 'evaluate-answer-upload',
      component: EvaluateAnswerUploadComponent,
      canActivate: [NgxPermissionsGuard],
      data: {
        title: 'Evaluate Answer Upload Sheet',
        urls: '',
        permissions:
        {
          only: ['teacher'],
          redirectTo: '/'
        }
      }
      
    }
    ]
  }
];



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/home.routing.ts